export function getPortfolioModelMetaUrl(account: unknown, modelId: unknown, portfolioId: unknown): string {
  return `/api/${String(account)}/m/${String(modelId)}/r/portfolio/${String(portfolioId)}`
}

export function getPortfolioUserPreferencesId(accountId: unknown, modelId: unknown, portfolioUUID: unknown): string {
  return `portfolioUserPreferences-${String(accountId)}${String(modelId)}${String(portfolioUUID)}`
}

export function getModelDatesId(modelId: unknown): string {
  return String(modelId)
}
